// ============================================================
// Hooks Barrel & Aliases
// ============================================================
// Exporting existing hooks and providing aliases requested in Phase 2

export { useAuth } from './useAuth';
export { useSchool } from './useSchool';
export { usePermission } from './usePermission';
export { useResponsive } from './useResponsive';
export { useDebounce } from './useDebounce';
export { usePageMeta } from './usePageMeta';
export { useDashboard } from './useDashboard';
export { useDashboardStats } from './useDashboardStats';
export { useDashboardCharts } from './useDashboardCharts';
export { useStudents } from './useStudents';
export { useStudent } from './useStudent';
export { useCreateStudent } from './useCreateStudent';
export { useUpdateStudent } from './useUpdateStudent';
import { useAuth as useOriginalAuth } from './useAuth';
import { useSchool as useOriginalSchool } from './useSchool';
import { usePermission as useOriginalPermission } from './usePermission';

export function useCurrentUser() {
  const { user } = useOriginalAuth();
  return user;
}

export function useCurrentSchool() {
  const { currentSchool, schoolId } = useOriginalSchool();
  return { currentSchool, schoolId };
}

export function useSchoolSwitcher() {
  const { schools, currentSchool, switchSchool, canSwitchSchool } = useOriginalSchool();
  return { schools, currentSchool, switchSchool, canSwitchSchool };
}

export function usePermissions() {
  return useOriginalPermission();
}
